import React from "react";
import { Search } from "lucide-react";
import ConversationItem from "./ConversationItem";

const ConversationsColumn = ({
  mobileSectionShown,
  keyword,
  setKeyword,
  conversationsFiltered,
  selectedConversation,
  currentUserId,
  onSelect,
  convListRef,
}) => (
  <div
    className={`${mobileSectionShown === "conversations" ? "flex" : "hidden"} lg:flex w-full lg:w-1/4 lg:min-w-[220px] border-r border-gray-200 dark:border-gray-700 flex-col bg-[#ffffff] dark:bg-darkBg1`}
  >
    {/* Search */}
    <div className="px-2 md:px-3 py-2 md:py-3 border-b border-gray-200 dark:border-gray-700">
      <div className="relative">
        <Search
          size={14}
          className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
        />
        <input
          type="text"
          placeholder="Search..."
          value={keyword}
          onChange={(e) => setKeyword(e.target.value)}
          className="w-full pl-8 pr-3 py-1.5 md:py-2 text-xs md:text-sm border border-gray-200 dark:border-gray-600 rounded-full bg-gray-50 dark:bg-darkBg2 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-400"
        />
      </div>
    </div>

    {/* List */}
    <div ref={convListRef} className="flex-1 overflow-y-auto">
      {conversationsFiltered.length === 0 ? (
        <div className="flex items-center justify-center h-32 text-sm text-gray-400">
          No conversations found
        </div>
      ) : (
        conversationsFiltered.map((conv) => (
          <ConversationItem
            key={conv._id}
            conversation={conv}
            currentUserId={currentUserId}
            isSelected={selectedConversation?._id === conv._id}
            onSelect={onSelect}
          />
        ))
      )}
    </div>
  </div>
);

export default ConversationsColumn;
